import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import GridFilterPanel from '../../commons/filters/GridFilterPanel.jsx';
import { buildPeriodoOptions } from '../../commons/filters/periodos.js';
import * as Utils from '../../commons/utils/Utils';
import {
	SOLICITUDES_FILTROS_STORAGE_KEY,
	buildSolicitudesFilterFields,
	getSolicitudesFilterDefaults,
} from './solicitudesFilterFields.js';

const OPTIONS_INIT = { estado: [], base: [], region: [], periodo: [] };

export const buildEstadoOptions = (intl) => [
	{ value: 'PENDIENTE', label: intl.formatMessage({ id: 'solicitudes.estado.pendiente', defaultMessage: 'PENDIENTE' }) },
	{ value: 'LIBERADA', label: intl.formatMessage({ id: 'solicitudes.estado.liberada', defaultMessage: 'LIBERADA' }) },
	{ value: 'RECHAZADA', label: intl.formatMessage({ id: 'solicitudes.estado.rechazada', defaultMessage: 'RECHAZADA' }) },
];

const SolicitudesGridFiltros = (props) => {
	const intl = useIntl();
	const [options, setOptions] = useState(OPTIONS_INIT);
	const [optionsLoading, setOptionsLoading] = useState(true);

	const fields = buildSolicitudesFilterFields(intl);

	const overrideState = () => {
		if (!props.overrideSignal) return null;
		const opcion = options.estado.find((o) => o.value === props.overrideSignal.estado);
		return { estado: opcion ? [opcion] : [], periodo: null };
	};

	useEffect(() => {
		setOptionsLoading(true);
		const fijas = { estado: buildEstadoOptions(intl), periodo: buildPeriodoOptions(intl) };
		Promise.all([
			Utils.getData('/bases/select-filtered-by-user/base/'),
			Utils.getData('/regiones/select'),
		])
			.then((data) => setOptions(Object.assign({}, fijas, { base: data[0] || [], region: data[1] || [] })))
			.catch(() => setOptions(Object.assign({}, OPTIONS_INIT, fijas)))
			.finally(() => setOptionsLoading(false));
	}, []);

	return (
		<GridFilterPanel
			open={props.open}
			fields={fields}
			options={options}
			defaults={getSolicitudesFilterDefaults(intl)}
			storageKey={SOLICITUDES_FILTROS_STORAGE_KEY}
			loading={props.loading || optionsLoading}
			applyOnMount={true}
			resetSignal={props.resetSignal}
			onResetSignalHandled={props.onResetSignalHandled}
			onApply={props.onApply}
			overrideState={overrideState()}
			overrideSignal={optionsLoading ? null : props.overrideSignal}
			onOverrideSignalHandled={props.onOverrideHandled}
		/>
	);
};

export default SolicitudesGridFiltros;
